import { defineStore } from 'pinia';

/**
 * @returns {{driverId?: string, termsAcceptance?: object, publicTerms?: boolean}}
 */
function preloadState() {
  return window.__PRELOAD_STATE__ ?? {};
}

/**
 * @param {{acceptedTerms: {timestamp: string, accepted: string}[], pendingAcceptances: {termVersionId: string|number}[]}} body
 */
function translateApiAcceptedTerms(body) {
  const acceptedTerm = body.acceptedTerms.find(t => t.accepted);

  return {
    termsAccepted: acceptedTerm != null,
    termsAcceptedAt: acceptedTerm?.timestamp != null ? new Date(acceptedTerm.timestamp) : null,
    termsRejected: body.acceptedTerms.some(t => !t.accepted),
    termVersionToAccept: body.pendingAcceptances[0]?.termVersionId,
  };
}

/* eslint-disable-next-line import/prefer-default-export */
export const useStore = defineStore({
  id: 'termosDeUso',

  state: () => {
    const initial = preloadState();
    if (initial.termsAcceptance != null) {
      Object.assign(initial, translateApiAcceptedTerms(initial.termsAcceptance));
      delete initial.termsAcceptance;
    }

    return {
      links: {
        backToApp: null,
      },
      publicTerms: false,
      termsAccepted: false,
      termsAcceptedAt: null,
      termsRejected: false,
      termVersionToAccept: null,
      driverId: null,
      ...initial,
    }
  },

  actions: {
    async fetchData() {
      const { driverId } = this;
      const url = `/_api_proxy/drivers/${driverId}/terms-acceptance`;

      const response = await fetch(url);
      if (!response.ok) {
        return;
      }

      /** @var {{acceptedTerms: {timestamp: string, accepted: string}[], pendingAcceptances: {termVersionId: string|number}[]}} body */
      const body = await response.json();
      Object.assign(this, translateApiAcceptedTerms(body));
    },

    async acceptTerms() {
      const { driverId, termVersionToAccept: termVersionId } = this;
      const url = `/_api_proxy/drivers/${driverId}/terms-acceptance`;
      const body = {
        termVersionId,
        accepted: true,
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return this.fetchData();
    },

    async rejectTerms() {
      const { driverId, termVersionToAccept: termVersionId } = this;
      const url = `/_api_proxy/drivers/${driverId}/terms-acceptance`;
      const body = {
        termVersionId,
        accepted: false,
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return this.fetchData();
    },
  },
});
